import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';
import { Typography } from '@mui/material';

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }) => {
  const theme = useTheme();

  return (
    <DrawerHeaderStyled theme={theme} open={open}>
      { /*<Logo isIcon={!open} sx={{ width: open ? 'auto' : 35, height: 35 }} />TODO*/}
      {!open && 
        <Typography variant='h4'>SD</Typography>
      }
      {open && 
        <Typography variant='h4'>Cygnus Dashboard</Typography>
      }
    </DrawerHeaderStyled>
  );
};

DrawerHeader.propTypes = {
  open: PropTypes.bool
};

export default DrawerHeader;
